import { apiClient } from "./client";
import type { AuthenticatedUser, LoginResponse, RefreshResponse } from "@/types/user";

export interface LoginPayload {
  login: string;
  password: string;
}

export async function loginStaff(payload: LoginPayload): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>("/auth/login", payload);
  return data;
}

export async function fetchMe(): Promise<AuthenticatedUser> {
  const { data } = await apiClient.get<AuthenticatedUser>("/auth/me");
  return data;
}

export async function refreshTokens(refreshToken: string): Promise<RefreshResponse> {
  const { data } = await apiClient.post<RefreshResponse>("/auth/refresh", { refreshToken });
  return data;
}

export async function logout(refreshToken: string | null): Promise<void> {
  await apiClient.post("/auth/logout", { refreshToken });
}

// Кабинет ученика — вход по телефону + одноразовому SMS-коду (ТЗ §2.11, сценарий 2).
export interface StudentCodeRequestResponse {
  sent: boolean;
  // В DEV-режиме API код возвращается прямо в ответе, чтобы прототип можно было
  // проверить без реального SMS-провайдера (ТЗ §9, допущение 4).
  devCode?: string;
}

export async function requestStudentLoginCode(phone: string): Promise<StudentCodeRequestResponse> {
  const { data } = await apiClient.post<StudentCodeRequestResponse>("/auth/student/request-code", { phone });
  return data;
}

export async function verifyStudentLoginCode(phone: string, code: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>("/auth/student/verify-code", { phone, code });
  return data;
}

// Саморегистрация преподавателя (ТЗ §2.11, сценарий 3 → создаёт Teacher/User со статусом PENDING).
export interface TeacherRegisterPayload {
  fullName: string;
  phone: string;
  branchId: string;
  subjectId: string;
  login: string;
  password: string;
}

export interface TeacherRegisterResponse {
  status: "PENDING";
  message: string;
}

export async function registerTeacher(payload: TeacherRegisterPayload): Promise<TeacherRegisterResponse> {
  const { data } = await apiClient.post<TeacherRegisterResponse>("/teachers/register", payload);
  return data;
}
